import { HistoryGraphData, HistoryGraphItem, HistoryGraphItemProps, HistoryGraphItemReducers, HistoryGraphItemState } from "@crispico/foundation-react/pages/Audit/historyGraphItem/HistoryGraphItem";
import { ReduxReusableComponents, RRCProps } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { ReactNode } from "react";
import { Checkbox } from "semantic-ui-react";
import { MissionGanttComponentRRC } from "./MissionGanttComponent";
import gql from "graphql-tag";
import _ from "lodash";
import { missionEntityDescriptor, missionEvent2EntityDescriptor, taskEntityDescriptor } from "AppEntityDescriptors";
import { apolloClientHolder } from "@crispico/foundation-react";
import { ID } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

export class HistoryGraphMissionGanttItemState extends HistoryGraphItemState {
    displayItemOnSeparateRowIfOverlap: boolean = false;
    showPlannedTime: boolean = false;
    entity: any;
}

export class HistoryGraphMissionGanttItemReducers extends HistoryGraphItemReducers<HistoryGraphMissionGanttItemState> {
}

export type HistoryGraphMissionGanttItemProps = RRCProps<HistoryGraphMissionGanttItemState, HistoryGraphMissionGanttItemReducers> & HistoryGraphItemProps;

export class HistoryGraphMissionGanttItem extends HistoryGraphItem<HistoryGraphMissionGanttItemProps> {

    async componentDidUpdate(prevProps: Readonly<HistoryGraphMissionGanttItemProps>) {
        if (prevProps && !_.isEqual(prevProps.entities, this.props.entities)) {
            await this.loadEntity();
        }
    }

    async componentDidMount() {
        await this.loadEntity();
    }

    protected async refresh() {
        await this.loadEntity();
    }

    async loadEntity() {
        if (!this.props.entities.length) {
            return;
        }
        const name: string = `${_.lowerFirst(missionEntityDescriptor.name)}Service_findById`;
        const fieldsToRequest = missionEntityDescriptor.getGraphQlFieldsToRequest() + " events { " + missionEvent2EntityDescriptor.getGraphQlFieldsToRequest() + " } \
            tasks { " + taskEntityDescriptor.getGraphQlFieldsToRequest(["id", "name", "taskGroup", "actualStartTime", "actualEndTime", "startTime", "endTime", "taskType", "taskType.color", "missionType", "comment", "quantity", "offloadStatus", "startAddress", "endAddress", "requiredEquipmentResourceQualificationType", "equipmentResourceFillPercentage"]) + " mission { id status } } ";
        const query = gql(`query q($id: Long) { 
                ${name}(id: $id) {
                    ${ID} ${fieldsToRequest}
                }
            }`);
        const entity = (await apolloClientHolder.apolloClient.query({ query: query, variables: { id: this.props.entities[0].id } })).data[name];
        this.props.r.setInReduxState({ entity });
    }


    protected getName(): string {
        return _msg("Mission2.detailsTab.label");
    }

    protected renderItem(): ReactNode {
        const { entity } = this.props.s;
        if (!entity) {
            return null;
        }
        // need to create the entities because the item render use GanttUtils.findByid, and it look in gantt props entities
        let entities: { [entityName: string]: { [id: number]: any } } = {};
        entities["Mission2"] = {};
        entities["Mission2"][entity.id] = entity;
        entities["Task"] = {};
        entity.tasks?.forEach((task: any) => {
            entities["Task"][task.id] = task;
        })
        entities["MissionEvent2"] = {};
        entity.events?.forEach((event: any) => {
            entities["MissionEvent2"][event.id] = event;
        })
        return <MissionGanttComponentRRC id="MissionDetails_MissionGanttComponent" entities={entities} showPlannedTime={this.props.s.showPlannedTime} displayItemOnSeparateRowIfOverlap={this.props.s.displayItemOnSeparateRowIfOverlap} markerDates={this.props.currentTime ? [this.props.currentTime] : []} />
    }

    protected getData(): HistoryGraphData[] {
        return this.props.s.entity ? [this.props.s.entity] : [];
    }

    protected renderInfoButton() {
        return <></>;
    }

    protected renderHeaderButtons() {
        return <div className="flex-container-row flex-center flex-wrap small-padding gap10">
            {_msg("MissionGanttComponent.displayItemOnSeparateRowIfOverlap.label")}
            <Checkbox style={{ paddingTop: 3 }} checked={this.props.s.displayItemOnSeparateRowIfOverlap} onClick={(_, data) => {
                this.props.r.setInReduxState({ displayItemOnSeparateRowIfOverlap: data.checked ? true : false });
            }
            } />
            {_msg("MissionGanttComponent.showPlannedTime.label")}
            <Checkbox style={{ paddingTop: 3 }} checked={this.props.s.showPlannedTime} onClick={(_, data) =>
                this.props.r.setInReduxState({ showPlannedTime: data.checked ? true : false })
            } />
        </div>;
    }
}

export const HistoryGraphMissionGanttItemRRC = ReduxReusableComponents.connectRRC(HistoryGraphMissionGanttItemState, HistoryGraphMissionGanttItemReducers, HistoryGraphMissionGanttItem);
HistoryGraphMissionGanttItemRRC.displayName = "historyGraphMissionGantt";
